module.exports = __webpack_public_path__ + "img/Ecoresponsable.5b45961a.png";